export default __webpack_public_path__ + "static/media/Proxima Nova Extrabold.53156c58.otf";